import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PropsWithChildren } from "react";

type HeaderVariant = "default" | "borderless";

const VARIANT_CLASSES: Record<HeaderVariant, string> = {
  default: "border-primary border-b px-5 py-3",
  // 993px matches useSmOrMdOrLgScreenMediaQuery, which callers use to toggle
  // their mobile-only controls inside this header.
  borderless: "gap-x-2 px-4 py-3 min-[993px]:gap-x-3 min-[993px]:py-4",
};

interface HeaderProps {
  variant?: HeaderVariant;
}

export const Header = ({
  variant = "default",
  children,
}: PropsWithChildren<HeaderProps>) => (
  <div
    className={classNames(
      "text-darkest flex h-14 min-h-14 items-center font-medium",
      VARIANT_CLASSES[variant],
    )}
  >
    {children}
  </div>
);
